
<div *ngFor="let page of pages | paginate: { itemsPerPage: pageSize, currentPage: currentPage }"></div>
             
<pagination-controls 
  [maxSize]="maxShownPages"
  previousLabel="Previous"
  nextLabel="Next"
  (pageChange)="pageChangeEvent($event)">
</pagination-controls>
